var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.67V33.25C17.5 34.0456 17.8161 34.8087 18.3787 35.3713C18.9413 35.9339 19.7044 36.25 20.5 36.25H35.5C36.2956 36.25 37.0587 35.9339 37.6213 35.3713C38.1839 34.8087 38.5 34.0456 38.5 33.25V24.67L29.572 30.163C29.0992 30.4538 28.5551 30.6078 28 30.6078C27.4449 30.6078 26.9008 30.4538 26.428 30.163L17.5 24.67Z",
    fill: "#0E241B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 22.908V22.75C38.5 21.9544 38.1839 21.1913 37.6213 20.6287C37.0587 20.0661 36.2956 19.75 35.5 19.75H20.5C19.7044 19.75 18.9413 20.0661 18.3787 20.6287C17.8161 21.1913 17.5 21.9544 17.5 22.75V22.908L27.214 28.886C27.4504 29.0314 27.7225 29.1084 28 29.1084C28.2775 29.1084 28.5496 29.0314 28.786 28.886L38.5 22.908Z",
    fill: "#0E241B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2efe6115515a0ecadd1b4464434eb1df.svg";
export { ForwardRef as ReactComponent };